import { Pipe, PipeTransform } from '@angular/core';
import { FeatureFlag, FeaturesService } from '@wdx/shared/utils';

@Pipe({
    name: 'hasFeature',
    standalone: false,
})
export class HasFeaturePipe implements PipeTransform {
    constructor(private featuresService: FeaturesService) {}
    transform(value: FeatureFlag): boolean {
        return this.featuresService.hasFeature(value);
    }
}
